import React from 'react';
import { Redirect } from 'expo-router';

// Keep old links working during client-side navigation and static hosting.
export default function BusinessRedirect() {
  return <Redirect href="/pricing#business" />;
}
